import { render, staticRenderFns } from "./TermRequest.vue?vue&type=template&id=65c33e31&"
import script from "./TermRequest.vue?vue&type=script&lang=js&"
export * from "./TermRequest.vue?vue&type=script&lang=js&"
import style0 from "./TermRequest.vue?vue&type=style&index=0&id=65c33e31&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports